import styled from 'styled-components';

const Container = styled.footer`
  background-color: #f08080;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  padding: 1.5rem;
  margin-bottom: 6.5vh;
  width: 100%;
  h3,
  p {
    margin: 0.5rem 0;
  }

  .socials__container {
    display: flex;
    justify-content: space-evenly;
    margin: 0.5rem 0;
    width: 100%;
  }
`;

const LogoContainer = styled.div`
  background-color: #f08080;
  border-radius: 25px 25px;
`;

const Logo = styled.img`
  width: 44px;
  height: 44px;
  -webkit-filter: invert(100%);
  filter: invert(100%);
`;

const Button = styled.button`
  border: none;
  background-color: white;
  margin: 0.5rem 0;
  padding: 0.5rem;
  color: #5865f2;
  font-weight: bold;
  font-size: 0.95rem;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  img {
    margin-right: 0.5rem;
  }
  span {
    height: 22px;
  }
`;

const Breadcrumbs = styled.div`
  margin: 0.5rem 0;
  ul {
    display: flex;
    align-items: center;
  }
`;

const Point = styled.div`
  border: 2px solid;
  height: 1px;
  width: 1px;
  color: white;
  border-radius: 50%;
  margin: 0.8rem;
`;

export { LogoContainer, Logo, Button, Breadcrumbs, Point };

export default Container;
